import Modal from "./MuiModal";

export default Modal;
